import { type MRDrawerItem } from '../../components/MRDrawer'
import DASHBOARD_LOGO from '../../../public/assets/icon_dashboard.svg'
import CAPTURED_LOGO from '../../../public/assets/captured.svg'
import SETTINGS_LOGO from '../../../public/assets/settings.svg'
import DASHBOARD_SELECTED_LOGO from '../../../public/assets/icon_dashboard_selected.svg'
import CAPTURED_SELECTED_LOGO from '../../../public/assets/captured_selected.svg'
import REPORTS_LOGO from '../../../public/assets/reports/menu-reports.svg'
import SETTINGS_SELECTED_LOGO from '../../../public/assets/settings_selected.svg'
import TUTORIAL_LOGO from '../../../public/assets/icon_menu_tutorial.svg'
import ADMIN_PORTAL_LOGO from '../../../public/assets/icon_adminportal.svg'

export const MRDrawerItems: MRDrawerItem[] = [
  {
    type: 'default',
    order: 0,
    text: 'dashboard',
    icon: DASHBOARD_LOGO,
    selected_icon: DASHBOARD_SELECTED_LOGO,
    selected: true,
  },
  {
    type: 'default',
    order: 1,
    text: 'timeEntries',
    icon: CAPTURED_LOGO,
    selected_icon: CAPTURED_SELECTED_LOGO,
    selected: false,
  },
  {
    type: 'default',
    order: 2,
    text: 'reports',
    icon: REPORTS_LOGO,
    selected_icon: REPORTS_LOGO,
    selected: false,
  },
  {
    type: 'tools',
    order: 3,
    text: 'settings',
    icon: SETTINGS_LOGO,
    selected_icon: SETTINGS_SELECTED_LOGO,
    selected: false,
  },
  {
    type: 'tools',
    order: 5,
    text: 'tutorial',
    icon: TUTORIAL_LOGO,
    selected_icon: TUTORIAL_LOGO,
    selected: false,
  },
  {
    type: 'tools',
    order: 6,
    text: 'adminPortal',
    icon: ADMIN_PORTAL_LOGO,
    selected_icon: ADMIN_PORTAL_LOGO,
    selected: false,
  },
]
